import SVG from "@Components/Icons/SVG";
export default class Preferences extends SVG {
    path = [
        "M 85.4494 38.5819 V 26.2357 C 85.4494 18.5529 85.4494 14.7115 83.9545 11.777 C 82.6393 9.1958 80.5404 7.0972 77.9594 5.782 C 75.0248 4.2869 71.1834 4.2869 63.5006 4.2869 H 34.2357 C 26.5529 4.2869 22.7115 4.2869 19.777 5.782 C 17.1958 7.0972 15.0972 9.1958 13.782 11.777 C 12.2869 14.7115 12.2869 18.5529 12.2869 26.2357 V 73.7915 C 12.2869 81.4743 12.2869 85.3157 13.782 88.25 C 15.0972 90.8313 17.1958 92.9298 19.777 94.2451 C 22.7115 95.7403 26.5529 95.7403 34.2357 95.7403 H 58.0134 M 58.0134 45.4409 H 30.5775 M 39.7229 63.7314 H 30.5775 M 67.1589 27.1502 H 30.5775 M 69.4453 63.7417 C 70.2509 61.4515 71.8412 59.52 73.9342 58.2898 C 76.0276 57.0597 78.4886 56.6101 80.8817 57.0206 C 83.2744 57.4311 85.445 58.675 87.0085 60.5324 C 88.572 62.3898 89.428 64.7407 89.4242 67.1688 C 89.4242 74.0227 79.1436 77.4494 79.1436 77.4494 M 79.276 91.1674 H 79.3216",
    ];
    strokeDetails = {
        stroke: "#0EABDB",
        strokeWidth: "6",
        strokeLinecap: "round",
        strokeLinejoin: "round",
    };
    evenOdd = true;
}
